import { Component, OnInit } from '@angular/core';
import { Reclamation } from '../../models/reclamation.model';
import { ReclamationService } from '../../services/reclamation.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-reclamations',
  templateUrl: './gestion-reclamations.component.html',
  styleUrls: ['./gestion-reclamations.component.css']
})
export class GestionReclamationsComponent implements OnInit {

  reclamations: Reclamation[] = [];
  filtreType: string = '';
  filtreStatut: string = '';

  constructor(
    private reclamationService: ReclamationService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.reclamationService.getAll().subscribe(data => {
      this.reclamations = data;
    });
  }

  get listeFiltree(): Reclamation[] {
    return this.reclamations.filter(r =>
      (!this.filtreType || r.type === this.filtreType) &&
      (!this.filtreStatut || r.statut === this.filtreStatut)
    );
  }

  get nombreEnAttente(): number {
    return this.reclamations.filter(r => r.statut === 'en_attente').length;
  }

  marquerTraitee(r: Reclamation): void {
    if (r.id === undefined) return;
    this.reclamationService.changerStatut(r.id, 'traitee').subscribe(() => {
      this.charger();
      this.journalService.ajouter(`Message de ${r.nom} marqué comme traité.`).subscribe();
    });
  }

  supprimer(r: Reclamation): void {
    if (r.id === undefined) return;
    if (confirm('Supprimer ce message ?')) {
      this.reclamationService.supprimer(r.id).subscribe(() => this.charger());
    }
  }
}
